function initTimeRangeInputs() {

    $(".timerange").each(function () {
        timeRangeUpdated($(this));
    });

    $(document).on('input', '.timerange', function () {
        timeRangeUpdated($(this))
    });
}

function timeRangeUpdated(selector) {
    var mins = parseInt(selector.val());
    selector.next('.info').html(toTimeOfDayLabelWithMin(mins));
}
